import React, { ReactNode } from "react";
import { Grid } from "@mui/material";

interface StepContainerProps {
  leftPanel?: ReactNode;
  rightPanel?: ReactNode;
  fullwidth?: boolean;
}

export const StepContainer: React.FC<StepContainerProps> = ({ leftPanel, rightPanel, fullwidth }) => {
  return (
    <Grid container spacing={3}>
      {/* Left side - Selection and Actions */}
      {leftPanel && !fullwidth && (
        <Grid item xs={12} md={6}>
          {leftPanel}
        </Grid>
      )}
      {leftPanel && fullwidth && (
        <Grid item xs={12} md={12}>
          {leftPanel}
        </Grid>
      )}



      {rightPanel && (
        <Grid item xs={12} md={6}>
          {rightPanel}
        </Grid>
      )}
    </Grid>
  );
};
